module.exports = __webpack_public_path__ + "static/img/scene-sbjs.ebf48dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene/scene-sbjs.png
// module id = c0lX
// module chunks = 1